import OnScreen from 'onscreen';

export default {
    init() {
        const os = new OnScreen();
        os.on('enter', '.add_fadeInUp ', (element) => {
            if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInUp');
                element.className += ' fadeInUp  show';
            }
        });

        os.on('enter', '.add_fadeInDown ', (element) => {
            if (element.classList.contains('add_fadeInDown') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInDown');
                element.className += ' fadeInDown  show';
            }
        });
        os.on('enter', '.add_fadeInRight ', (element) => {
            if (element.classList.contains('add_fadeInRight') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInRight');
                element.className += ' fadeInRight  show';
            }
        });

        os.on('enter', '.add_fadeInLeft ', (element) => {
            if (element.classList.contains('add_fadeInLeft') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInLeft');
                element.className += ' fadeInLeft  show';
            }
        });

        os.on('enter', '.js-highlights__box__inner__item__image ', (element) => {
            if (!element.classList.contains('js-highlights__box__inner__item__image--active')) {
                element.className += ' js-highlights__box__inner__item__image--active';
            }
        });

        os.on('enter', '.home__work ', () => {
            Array.prototype.forEach.call(document.getElementsByClassName('home__dots'), function (element) {
                if (!element.classList.contains('home__dots--active')) {
                    element.className += ' home__dots--active';
                }
            });
        });

        if ($(window).width() < 990) {

            $('#team__inner').slick({
                dots: false,
                infinite: true,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '50px',
                        },
                    },
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],
            });
        }



        post_height('.js-services__box__item__title');
        post_height('.js-services__box__item__text');
    },
    finalize() {
        var type = $('.position__header__info__type dd').html();
        var title = $('.position__header__title h1').html();
        $('.cf__position').val( title +' '+ type);
    },
};

function post_height($element) {
    $($element).removeAttr('style');
    setTimeout(function () {
        var maxheight = 0;
        $($element).each(function () {
            if ($(this).height() > maxheight) {
                maxheight = $(this).height();
            }
        });

        $($element).css('min-height', maxheight + 'px');
    }, 200);
}


// WEBPACK FOOTER //
// ./scripts/routes/single-jobs.js